import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import "../../assets/css/feedbackForm.css";


function AdminFeedbackForm() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    const [form, setForm] = useState({

        name: "",
        email: "",
        rating: 5,
        message: ""

    });

    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value

        });

    };

    const handleSubmit = async (e) => {
   
        e.preventDefault();
  setLoading(true);
        try {

            await addDoc(collection(db, "feedbacks"), {

                name: form.name,
                email: form.email,
                rating: Number(form.rating),
                message: form.message,
                createdAt: new Date()

            });

            setPopup({
    show: true,
    type: "success",
    message: "Feedback Submitted Successfully"
});

            // Reset the form
            setForm({

                name: "",
                email: "",
                rating: 5,
                message: ""

            });
            setLoading(false);

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

    navigate("/admin/feedbackPage");

}, 2000);

        } catch (error) {

            console.error("Error submitting feedback:", error);
setPopup({
    show: true,
    type: "error",
    message: "Failed to submit feedback. Please try again."
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        }

    };

    return (
          
 <>
    {popup.show && (

        <div className={`luxury-popup ${popup.type}`}>

            <div className="popup-icon">

                {popup.type === "success"
                    ? "✓"
                    : "✕"}

            </div>

            <div className="popup-content">

                <h3>

                    {popup.type === "success"
                        ? "Success"
                        : "Error"}

                </h3>

                <p>

                    {popup.message}

                </p>

            </div>

        </div>

    )}

    <form
        className="customer-feedback-form"
        onSubmit={handleSubmit}
    >

    <input
        className="customer-feedback-form-input"
        type="text"
        name="name"
        placeholder="Your Name"
        value={form.name}
        onChange={handleChange}
        required
    />

    <input
        className="customer-feedback-form-input"
        type="email"
        name="email"
        placeholder="Your Email"
        value={form.email}
        onChange={handleChange}
        required
    />

    <select
        className="customer-feedback-form-select"
        name="rating"
        value={form.rating}
        onChange={handleChange}
    >

        <option value="5">★★★★★ Excellent</option>
        <option value="4">★★★★☆ Very Good</option>
        <option value="3">★★★☆☆ Good</option>
        <option value="2">★★☆☆☆ Fair</option>
        <option value="1">★☆☆☆☆ Poor</option>

    </select>

    <textarea
        className="customer-feedback-form-textarea"
        rows="6"
        name="message"
        placeholder="Write your feedback..."
        value={form.message}
        onChange={handleChange}
        required
    />

    <button
        className="customer-feedback-form-button"
        type="submit"
        disabled={loading}
    >
        {loading ? "Sending Feedback..." : "Send Feedback"}
    </button>

</form>
  </>   
    );
  
}

export default AdminFeedbackForm;